import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/admin", icon: "▦" },
  { label: "Orders", path: "/admin/orders", icon: "◫" },
  { label: "Listings", path: "/admin/listings", icon: "☰" },
  { label: "Create Listing", path: "/admin/create-listing", icon: "+" },
  { label: "Analytics", path: "/admin/analytics", icon: "◈" },
  { label: "Customers", path: "/admin/customers", icon: "◯" },
  { label: "Inventory", path: "/admin/inventory", icon: "▤" },
  { label: "Messages", path: "/admin/messages", icon: "✉" },
  { label: "Returns", path: "/admin/returns", icon: "↩" },
];

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = useState(null);

  return (
    <div style={styles.layout}>

      {/* SIDEBAR */}
      <div style={styles.sidebar}>

        {/* Logo */}
        <div style={styles.logoWrap}>
          <div style={styles.logoMark}>E</div>
          <div>
            <div style={styles.logoText}>ELEVEN</div>
            <div style={styles.logoSub}>Control Center</div>
          </div>
        </div>

        <div style={styles.divider} />

        {/* Nav */}
        <nav style={styles.nav}>
          {NAV_ITEMS.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.path}
                style={{
                  ...styles.navItem,
                  ...(isActive ? styles.navItemActive : {}),
                  ...(hovered === item.path && !isActive ? styles.navItemHover : {})
                }}
                onMouseEnter={() => setHovered(item.path)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => navigate(item.path)}
              >
                <span style={styles.navIcon}>{item.icon}</span>
                <span>{item.label}</span>
                {isActive && <div style={styles.activeBar} />}
              </button>
            );
          })}
        </nav>

        <div style={styles.sidebarFooter}>
          <button
            style={styles.backButton}
            onClick={() => navigate("/")}
          >
            ← Back to Store
          </button>
        </div>

      </div>

      {/* MAIN CONTENT */}
      <div style={styles.content}>
        {children}
      </div>

    </div>
  );
}

const styles = {
  layout: {
    display: "flex",
    minHeight: "100vh",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui",
    background: "#0A0A0F"
  },

  sidebar: {
    width: 220,
    background: "linear-gradient(180deg, #0F0F17 0%, #0A0A0F 100%)",
    borderRight: "1px solid rgba(255,255,255,0.06)",
    padding: "28px 16px",
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    zIndex: 100
  },

  logoWrap: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "0 8px",
    marginBottom: 28
  },

  logoMark: {
    width: 36,
    height: 36,
    borderRadius: 10,
    background: "linear-gradient(135deg, #fff 0%, #c8c8d0 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    fontWeight: 900,
    color: "#0A0A0F",
    flexShrink: 0
  },

  logoText: {
    fontSize: 15,
    fontWeight: 800,
    color: "#ffffff",
    letterSpacing: 1.5
  },

  logoSub: {
    fontSize: 11,
    color: "rgba(255,255,255,0.35)",
    fontWeight: 500,
    letterSpacing: 0.3,
    marginTop: 1
  },

  divider: {
    height: 1,
    background: "rgba(255,255,255,0.06)",
    marginBottom: 20
  },

  nav: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    flex: 1
  },

  navItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "11px 12px",
    borderRadius: 10,
    border: "none",
    background: "transparent",
    color: "rgba(255,255,255,0.45)",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
    textAlign: "left",
    width: "100%",
    position: "relative",
    transition: "all 0.15s ease",
    letterSpacing: 0.1
  },

  navItemActive: {
    background: "rgba(255,255,255,0.08)",
    color: "#ffffff",
    fontWeight: 700
  },

  navItemHover: {
    background: "rgba(255,255,255,0.04)",
    color: "rgba(255,255,255,0.7)"
  },

  navIcon: {
    fontSize: 16,
    width: 20,
    textAlign: "center",
    opacity: 0.8
  },

  activeBar: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    width: 3,
    height: 20,
    borderRadius: 999,
    background: "#ffffff"
  },

  sidebarFooter: {
    borderTop: "1px solid rgba(255,255,255,0.06)",
    paddingTop: 16,
    marginTop: 16
  },

  backButton: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 10,
    background: "transparent",
    color: "rgba(255,255,255,0.35)",
    fontSize: 13,
    fontWeight: 500,
    cursor: "pointer",
    textAlign: "left",
    transition: "all 0.15s ease"
  },

content: {
  flex: 1,
  marginLeft: 240,
  background: "#F4F5F7",
  minHeight: "100vh",
  padding: "40px 48px",
  overflowY: "auto"
}
};